"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.btnDanger = exports.btnSecondary = exports.btnDisabled = exports.btnPrimary = void 0;
var buttonClasses_1 = require("./buttonClasses");
Object.defineProperty(exports, "btnPrimary", { enumerable: true, get: function () { return buttonClasses_1.btnPrimary; } });
Object.defineProperty(exports, "btnDisabled", { enumerable: true, get: function () { return buttonClasses_1.btnDisabled; } });
Object.defineProperty(exports, "btnSecondary", { enumerable: true, get: function () { return buttonClasses_1.btnSecondary; } });
Object.defineProperty(exports, "btnDanger", { enumerable: true, get: function () { return buttonClasses_1.btnDanger; } });
